import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'app-config';
import { ChainRepository } from '../repository';
import { CHAIN_ID, ChainId } from '@31third/common';
import type { Metadata } from '@reown/appkit-core';
import type { AppKitNetwork } from '@reown/appkit-common';
import {
  mainnet,
  polygon,
  optimism,
  arbitrum,
  bsc,
  base,
  avalanche,
  blast,
} from '@reown/appkit/networks';

@Injectable({
  providedIn: 'root',
})
export class WalletModalConfigService {
  private readonly metadata = {
    name: '31Third',
    description: '31Third App',
    url: 'https://app.31third.com',
    icons: [
      'data:image/png;base64,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',
    ],
  };

  constructor(
    @Inject(APP_CONFIG) private appConfig: any,
    private readonly chainRepository: ChainRepository,
  ) {}

  public getNetworks(): AppKitNetwork[] {
    return this.chainRepository.getEnabledChains().map(chain => {
      const appKitNetwork = this.findAppKitNetwork(chain.identifier);
      if (appKitNetwork) {
        return appKitNetwork;
      }

      return {
        id: chain.getIdentifierAsDecimal(),
        name: chain.name,
        nativeCurrency: this.getChainNativeCurrency(chain.identifier),
        explorerUrl: chain.blockExplorerLink,
        rpcUrls: {
          default: {
            http: [
              this.getBlockchainApiRpcUrl(
                chain.getIdentifierAsDecimal(),
                'eip155',
              ),
            ],
          },
        },
        blockExplorers: {
          default: { name: 'Explorer', url: chain.blockExplorerLink },
        },
      } as AppKitNetwork;
    });
  }

  private findAppKitNetwork(chainId: ChainId): AppKitNetwork | undefined {
    switch (chainId) {
      case CHAIN_ID.ETHEREUM:
        return mainnet;
      case CHAIN_ID.POLYGON:
        return polygon;
      case CHAIN_ID.OPTIMISM:
        return optimism;
      case CHAIN_ID.ARBITRUM_ONE:
        return arbitrum;
      case CHAIN_ID.BSC:
        return bsc;
      case CHAIN_ID.BASE:
        return base;
      case CHAIN_ID.AVALANCHE:
        return avalanche;
      case CHAIN_ID.BLAST:
        return blast;
      default:
        return undefined;
    }
  }

  private getChainNativeCurrency(chainId: ChainId): ChainNativeCurrency {
    switch (chainId) {
      case CHAIN_ID.ETHEREUM:
      case CHAIN_ID.ETHEREUM_31THIRD_FORK:
      case CHAIN_ID.ETHEREUM_LOCAL_FORK:
      case CHAIN_ID.OPTIMISM:
      case CHAIN_ID.OPTIMISM_31THIRD_FORK:
      case CHAIN_ID.OPTIMISM_LOCAL_FORK:
      case CHAIN_ID.ARBITRUM_ONE:
        return {
          name: 'Ether',
          symbol: 'ETH',
          decimals: 18,
        };
      case CHAIN_ID.POLYGON:
        return {
          name: 'Polygon',
          symbol: 'POL',
          decimals: 18,
        };
      case CHAIN_ID.BSC:
        return {
          name: 'BNB',
          symbol: 'BNB',
          decimals: 18,
        };
      default:
        throw new Error(`No currency for chain#${chainId}`);
    }
  }

  private getBlockchainApiRpcUrl(
    chainId: number | string,
    namespace: 'eip155',
  ) {
    return `https://rpc.walletconnect.org/v1/?chainId=${namespace}:${chainId}`;
  }

  public getWalletConnectProjectId(): string {
    return this.appConfig.walletConnectProjectId;
  }

  public getMetadata(): Metadata {
    return this.metadata;
  }
}

type ChainNativeCurrency = {
  name: string;
  /** 2-6 characters long */
  symbol: string;
  decimals: number;
};
